<template>
    <div class="new_product">
        <div class="banner">
                <el-carousel height="650px" arrow="always" >
                    <el-carousel-item v-for="(item,index) in bannerList" :key="index">
                        <img v-if="languageType == 0" @click="toProductdetail(item.category,item.productName)" :src="item.picUrl"/>
                        <img v-else @click="toProductdetail(item.category,item.productName)" :src="item.enPicUrl"/>
                    </el-carousel-item>
                </el-carousel>
        </div>
        <div class="newproduct_list">
            <ul>
                <li v-for="(item,index) in newproductList" :key="index" @click="toProductdetail(item.categoryId,item.productName)">
                    <img v-if="languageType == 0" :src="item.picUrl"/>
                    <img v-else :src="item.enPicUrl"/>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    props:['languageType'],
    data () {
        return {
            bannerList:[],
            newproductList:[],
        }
    },
    created () {
        this.$emit('changeIndex',2)
        this.getNewproductList()
        document.documentElement.scrollTop = 0
    },
    watch:{
        'languageType':function(a,b) {
            if(a != b){
                this.getNewproductList()
            }
        }

    },
    methods: {
        getNewproductList () {
            this.$http({
                url: this.$http.adornUrl('/web/productRecommend/list'),
                method: 'post',
                data: {
                }
                }).then(({data}) => {
                if (data && data.code === 0) {
                    let arr = []
                    data.page.list.forEach( item => {
                        if(item.client == 1){
                            if(this.languageType == 0 && item.picUrl){
                                arr.push(item)
                            }else if(this.languageType == 1 && item.enPicUrl){
                                 arr.push(item)
                            }
                        }
                    })
                    this.newproductList = arr
                    this.bannerList = arr.reverse()
                } else {
                    this.newproductList = []
                     this.bannerList = []
                }
            })
        },
        toProductdetail (id,name) {
            this.$router.push({ name: 'productdetail',query:{key:JSON.stringify(name),id:JSON.stringify(id)}}),
            this.$emit('changeIndex',5)
        }
    }
}
</script>

<style lang="less" scoped>
    .new_product {
        max-width: 1920px;
        .banner {
            height: 650px;
            img {
                    height: 650px;
                    cursor: pointer;
                    }
        }
        .newproduct_list {
            width: 100%;
            margin-top: 20px;
            ul {
                li {
                    height: 650px;
                    margin-bottom: 20px;
                    cursor: pointer;
                    img {
                        width: 100%;
                        height: 650px;
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/newproduct.vue